export const noopTraceWith = () => (fn) => fn();
//# sourceMappingURL=trace-with.js.map